/** Keep users logged in for 7 days from last activity (shop cookie + admin JWT). */
export const SESSION_IDLE_TTL_SEC = 7 * 24 * 60 * 60;
export const SESSION_IDLE_TTL_MS = SESSION_IDLE_TTL_SEC * 1000;
